import React, { FC } from "react";

interface IIcon {
  theme?: string;
}
export const IconProfile: FC<IIcon> = ({ theme }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99967 9.99992C11.8413 9.99992 13.333 8.50825 13.333 6.66659C13.333 4.82492 11.8413 3.33325 9.99967 3.33325C8.15801 3.33325 6.66634 4.82492 6.66634 6.66659C6.66634 8.50825 8.15801 9.99992 9.99967 9.99992ZM9.99967 11.6666C7.77467 11.6666 3.33301 12.7833 3.33301 14.9999V16.6666H16.6663V14.9999C16.6663 12.7833 12.2247 11.6666 9.99967 11.6666Z"
        fill={theme === "light" ? "#006398" : "#94CCFF"}
      />
    </svg>
  );
};
